import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom';
import { 
  FaUpload, 
  FaTimes, 
  FaImage, 
  FaCheck, 
  FaExclamationTriangle,
  FaInfoCircle,
  FaSave,
  FaEye
} from 'react-icons/fa';
import './AddProductVendor.css';
import VendorSidebar from './VendorSidebar';
import Navbar from '../components/navbar';

const AddProductVendor = () => {
  const [formData, setFormData] = useState({
    name: '',
    slug: '',
    smalldescription: '',
    description: '',
    active: true,
    originalPrice: '',
    sellingPrice: '',
    category: '',
    selectedSubCategory: '',
    keywords: ['', '', '', '']
  });

  const [vendorId, setVendorId] = useState('');
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubCategories] = useState([]);
  const [filteredSubcategories, setFilteredSubCategories] = useState([]);
  const [images, setImages] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [qualityScore, setQualityScore] = useState(0);

  useEffect(() => {
    fetchCategories();
    fetchSubCategories();
    const token = localStorage.getItem('vendortoken');
    const storedVendorId = localStorage.getItem('vendorId');
    
    if (token && storedVendorId) {
      try {
        jwtDecode(token);
        setVendorId(storedVendorId);
      } catch (err) {
        console.error('Invalid token');
      }
    } else {
      alert('Vendor not authenticated. Please log in.');
    }
  }, []);

  useEffect(() => {
    calculateQualityScore();
  }, [formData, images]);

  const calculateQualityScore = () => {
    let score = 0;
    if (formData.name.length > 10) score += 20;
    if (formData.description.length > 50) score += 20;
    if (formData.smalldescription.length > 20) score += 15;
    if (images.length >= 3) score += 25;
    if (formData.keywords.filter(k => k.length > 0).length >= 2) score += 20;
    setQualityScore(Math.min(score, 100));
  };

  const fetchCategories = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/getCategoryHome`);
      if (res.data.status === 'ok') setCategories(res.data.data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchSubCategories = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/getSubCategory`);
      if (res.data.status === 'ok') setSubCategories(res.data.data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleKeywordChange = (index, value) => {
    const newKeywords = [...formData.keywords];
    newKeywords[index] = value;
    setFormData(prev => ({
      ...prev,
      keywords: newKeywords
    }));
  };

  const handleCategoryChange = (e) => {
    const selectedCategoryId = e.target.value;
    setFormData(prev => ({
      ...prev,
      category: selectedCategoryId,
      selectedSubCategory: ''
    }));
    
    const filtered = subcategories.filter(sub => sub.Category === selectedCategoryId);
    setFilteredSubCategories(filtered);
  };

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    
    files.forEach(file => {
      if (file && file.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onload = (event) => {
          setImages(prev => [...prev, file]);
          setImagePreviews(prev => [...prev, event.target.result]);
        };
        reader.readAsDataURL(file);
      }
    });
  };

  const removeImage = (index) => {
    setImages(prev => prev.filter((_, i) => i !== index));
    setImagePreviews(prev => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  if (!vendorId) return alert("Invalid vendor ID");
  
  setLoading(true);
  
  const submitData = new FormData();
  
  // Add form fields
  submitData.append('vendorId', vendorId);
  submitData.append('name', formData.name);
  submitData.append('slug', formData.slug);
  submitData.append('smalldescription', formData.smalldescription);
  submitData.append('description', formData.description);
  submitData.append('active', formData.active);
  submitData.append('originalPrice', formData.originalPrice);
  submitData.append('sellingPrice', formData.sellingPrice);
  submitData.append('category', formData.category);
  submitData.append('selectedSubCategory', formData.selectedSubCategory); // Fixed field name
  submitData.append('keywords', JSON.stringify(formData.keywords));
  
  // Add images
  images.forEach((img) => {
    if (img) submitData.append('image', img);
  });

  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/addProduct`, {
      method: 'POST',
      body: submitData,
    });

    const data = await res.json();

    if (data.status === 'ok') {
         toast.success('Product added successfully!');

      window.location.href = "/Vendor/AllProduct";
    } else {
      alert(data.message || 'Product addition failed!');
    }
  } catch (err) {
    console.error(err);
    alert('An error occurred during submission.');
  } finally {
    setLoading(false);
  }
};

  return (
    <>
      <Navbar />
      <ToastContainer position="top-center" autoClose={3000} />
      <div className='main-container'>
        <VendorSidebar />
        
        <div className='content-area'>
          {/* Header */}
          <div className="page-header">
            <div className="header-content">
              <h1 className="page-title">Create New Product</h1>
              <div className="header-actions">
                <button className="help-btn">
                  <FaInfoCircle /> Help Center
                </button>
                <button className="feedback-btn">
                  Your Feedback
                </button>
              </div>
            </div>
            
          
          </div>

          <div className="form-container-vendor">
            <div className="form-content">
              
              {/* Category Selection */}
              <div className="form-section">
                <div className="section-header">
                  <h3>Category Selection</h3>
                </div>
                
                <div className="category-selector">
                  <div className="current-category">
                    <span className="label">Currently Selected Category:</span>
                    <span className="category-name">
                      {formData.category ? categories.find(c => c._id === formData.category)?.name : 'None'}
                    </span>
                    <button className="change-category-btn" type="button">
                      Change Category
                    </button>
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label required">Category</label>
                    <select 
                      className="form-control" 
                      value={formData.category} 
                      onChange={handleCategoryChange} 
                      required
                    >
                      <option value="">Select category</option>
                      {categories.map((cat) => (
                        <option key={cat._id} value={cat._id}>{cat.name}</option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group">
                    <label className="form-label required">Sub Category</label>
                    <select 
                      className="form-control" 
                      value={formData.selectedSubCategory} 
                      onChange={(e) => handleInputChange('selectedSubCategory', e.target.value)} 
                      required
                    >
                      <option value="">Select subcategory</option>
                      {filteredSubcategories.map((sub) => (
                        <option key={sub._id} value={sub._id}>{sub.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              {/* Primary Product Information */}
              <div className="form-section">
                <div className="section-header">
                  <h3>Primary Product Information</h3>
                  <p className="section-subtitle">Ensure accurate search results and make your product more attractive</p>
                </div>

                <div className="form-group">
                  <label className="form-label required">
                    Product Name and Short Description
                  </label>
                  <textarea 
                    className="form-control product-name-input"
                    placeholder="Please enter product name and short description"
                    value={formData.name}
                    onChange={(e) => handleInputChange('name', e.target.value)}
                    maxLength="128"
                    required
                  />
                  <div className="char-count">{formData.name.length}/128</div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Slug</label>
                    <input 
                      type="text" 
                      className="form-control" 
                      value={formData.slug} 
                      onChange={(e) => handleInputChange('slug', e.target.value)} 
                      placeholder="product-url-slug"
                      required 
                    />
                  </div>
                </div>
              </div>

              {/* Search Optimization Keywords */}
              <div className="form-section">
                <div className="section-header">
                  <h3>Search Optimization Keywords</h3>
                </div>

                <div className="keywords-grid">
                  {formData.keywords.map((keyword, index) => (
                    <div key={index} className="form-group">
                      <label className="form-label">
                        {index < 2 ? `* Keyword ${index + 1}` : `Keyword ${index + 1}`}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Please Input"
                        value={keyword}
                        onChange={(e) => handleKeywordChange(index, e.target.value)}
                        maxLength={index < 2 ? "50" : "50"}
                      />
                      <div className="char-count">{keyword.length}/{index < 2 ? "50" : "50"}</div>
                    </div>
                  ))}
                </div>
                
                <button type="button" className="view-hot-keywords">
                  View Hot Keywords
                </button>
              </div>

              {/* Product Images */}
              <div className="form-section">
                <div className="section-header">
                  <h3>Product Images</h3>
                  <p className="section-subtitle">Upload high-quality images to showcase your product</p>
                </div>

                <div className="image-upload-area">
                  <div className="upload-grid">
                    {imagePreviews.map((preview, index) => (
                      <div key={index} className="image-preview-card">
                        <img src={preview} alt={`Preview ${index + 1}`} />
                        <button 
                          type="button" 
                          className="remove-image-btn"
                          onClick={() => removeImage(index)}
                        >
                          <FaTimes />
                        </button>
                        {index === 0 && <span className="main-image-badge">Main</span>}
                      </div>
                    ))}
                    
                    {images.length < 10 && (
                      <div className="upload-placeholder">
                        <input
                          type="file"
                          accept="image/*"
                          multiple
                          onChange={handleImageUpload}
                          className="hidden-file-input"
                          id="image-upload"
                        />
                        <label htmlFor="image-upload" className="upload-label">
                          <FaUpload className="upload-icon" />
                          <span>Upload Images</span>
                          <small>PNG, JPG, GIF up to 10MB</small>
                        </label>
                      </div>
                    )}
                  </div>
                  
                  <div className="upload-info">
                    <p><strong>Image Requirements:</strong></p>
                    <ul>
                      <li>Minimum resolution: 800x800 pixels</li>
                      <li>Maximum file size: 10MB per image</li>
                      <li>Supported formats: PNG, JPG, GIF</li>
                      <li>Upload up to 10 images</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Product Details */}
              <div className="form-section">
                <div className="section-header">
                  <h3>Product Details</h3>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label required">Original Price (₹)</label>
                    <input 
                      type="number" 
                      className="form-control" 
                      value={formData.originalPrice} 
                      onChange={(e) => handleInputChange('originalPrice', e.target.value)} 
                      placeholder="0.00"
                      required 
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label required">Selling Price (₹)</label>
                    <input 
                      type="number" 
                      className="form-control" 
                      value={formData.sellingPrice} 
                      onChange={(e) => handleInputChange('sellingPrice', e.target.value)} 
                      placeholder="0.00"
                      required 
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label className="form-label required">Short Description</label>
                  <textarea 
                    className="form-control" 
                    rows="3" 
                    value={formData.smalldescription} 
                    onChange={(e) => handleInputChange('smalldescription', e.target.value)} 
                    placeholder="Brief description of your product..."
                    maxLength="300"
                    required 
                  />
                  <div className="char-count">{formData.smalldescription.length}/300</div>
                </div>

                <div className="form-group">
                  <label className="form-label required">Detailed Description</label>
                  <textarea 
                    className="form-control" 
                    rows="6" 
                    value={formData.description} 
                    onChange={(e) => handleInputChange('description', e.target.value)} 
                    placeholder="Detailed description of your product features, specifications, and benefits..."
                    maxLength="2000"
                    required 
                  />
                  <div className="char-count">{formData.description.length}/2000</div>
                </div>

                <div className="form-group">
                  <label className="form-label">Product Status</label>
                  <div className="radio-group">
                    <label className="radio-option">
                      <input 
                        type="radio" 
                        value={true} 
                        checked={formData.active === true} 
                        onChange={() => handleInputChange('active', true)} 
                      />
                      <span className="radio-custom"></span>
                      Active
                    </label>
                    <label className="radio-option">
                      <input 
                        type="radio" 
                        value={false} 
                        checked={formData.active === false} 
                        onChange={() => handleInputChange('active', false)} 
                      />
                      <span className="radio-custom"></span>
                      Inactive
                    </label>
                  </div>
                </div>
              </div>

              {/* Form Actions */}
              <div className="form-actions">
                <button type="button" className="btn btn-secondary">
                  <FaEye /> Preview
                </button>
                <button type="button" className="btn btn-outline">
                  <FaSave /> Save Draft
                </button>
                <button 
                  type="submit" 
                  className="btn btn-primary"
                  disabled={loading}
                  onClick={handleSubmit}
                >
                  {loading ? 'Submitting...' : 'Submit'}
                </button>
              </div>
            </div>

            {/* Quality Score Sidebar */}
            <div className="quality-sidebar">
              <div className="quality-card">
                <h4>Product Quality Score</h4>
                <div className="quality-circle">
                  <div className="quality-score">{qualityScore}</div>
                  <div className="quality-label">/ 100</div>
                </div>
                <button className="check-score-btn">
                  <FaCheck /> Check Score
                </button>
                
                <div className="quality-tips">
                  <h5>Improve Your Score:</h5>
                  <ul>
                    <li className={formData.name.length > 10 ? 'completed' : ''}>
                      Add detailed product name (10+ chars)
                    </li>
                    <li className={formData.description.length > 50 ? 'completed' : ''}>
                      Write comprehensive description (50+ chars)
                    </li>
                    <li className={images.length >= 3 ? 'completed' : ''}>
                      Upload at least 3 product images
                    </li>
                    <li className={formData.keywords.filter(k => k.length > 0).length >= 2 ? 'completed' : ''}>
                      Add relevant keywords (2+ keywords)
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddProductVendor;